import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsTableLayout',
  setup(__props) {

// Layout component per tabelle risultati ricerca

return { __sfc: true, }
}

})